import React from 'react';
import DdhpError from '../utilities/ddhpError';
import Errors from './errors';
import styles from './teamSubmission.module.scss';

export default class Stats extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            stats:[],
            club:{},
            errors:[]
        };
        this.sort = this.sort.bind(this);
        this.render = this.render.bind(this);
    }

    async componentDidUpdate(){
        if (!this.props.ClubName || !this.props.Season){
            return;
        }

        if (this.props.ClubName === this.state.clubName && this.props.Season === this.state.season){
            return;
        }

        this.setState({
            clubName: this.props.ClubName,
            season: this.props.Season
        });

        const statsApi = `/api/clubs/${this.props.ClubName}/${this.props.Season}`;
        const statsResponse = await fetch(statsApi);

        if (!statsResponse.ok){
            this.setState({errors:[
                DdhpError.RequestFailed(statsResponse)
            ]});
            return;
        }

        const stats = await statsResponse.json();
        this.setState({
            stats: stats.statRows,
            club: stats.club
        });
    }

    sort(field, direction){
        const that = this;

        return event => {
            event.preventDefault();

            var fetch = data => {throw new Error('No field matched sort')};
            switch (field){
                case 'playerName':
                    fetch = data => data.playerName;
                    break;
                case 'afl':
                    fetch = data => data.aflClubName;
                    break;
                case 'af':
                    fetch = data => data.avgF;
                    break;
                case 'am':
                    fetch = data => data.avgM;
                    break;
                case 'ar':
                    fetch = data => data.avgR;
                    break;
                case 'at':
                    fetch = data => data.avgT;
                    break;
                case 'games':
                    fetch = data => data.games;
                    break;
            }

            var sorted = [];
            if (!direction || direction === 'up') {
                sorted = that.state.stats.sort((a,b) => fetch(a) > fetch(b));
            } else {
                sorted = that.state.stats.sort((a,b) => fetch(a) < fetch(b));
            }

            this.setState({stats: sorted});
        };
    }

    render(){
        var row = function(data) {
            var style = 'unselected';
            if (this.props.Team)
            {
                if (this.props.Team.f && this.props.Team.f.filter(t => t === data.contractId).length > 0) {
                    style = styles.fselected;
                } else if (this.props.Team.m && this.props.Team.m.filter(t => t === data.contractId).length > 0) {
                    style = styles.mselected;
                } else if (this.props.Team.r && this.props.Team.r.filter(t => t === data.contractId).length > 0){
                    style = styles.rselected;
                } else if (this.props.Team.t && this.props.Team.t.filter(t => t === data.contractId).length > 0){
                    style = styles.tselected;
                } else if (this.props.Team.i && this.props.Team.i.filter(t => t === data.contractId).length > 0){
                    style = styles.iselected;
                } else if (this.props.Team.e && this.props.Team.e.filter(t => t === data.contractId).length > 0){
                    style = styles.eselected;
                }
            }

            return (
                <tr className={style} key={data.contractId}>
                    <td className={styles.playerName}>{data.playerName}</td>
                    <td>{data.aflClubName}</td>
                    <td className={styles.f}>{data.avgF.toFixed(2)}</td>
                    <td className={styles.m}>{data.avgM.toFixed(2)}</td>
                    <td className={styles.r}>{data.avgR.toFixed(2)}</td>
                    <td className={styles.t}>{data.avgT.toFixed(2)}</td>
                    <td className={styles.number}>{data.games}</td>
                </tr>
            );
        };

        row = row.bind(this);

        return(
            <div>
                <Errors Errors={this.state.errors} />
                <table className={styles.stats}>
                    <thead>
                        <tr>
                            <th><button className={styles.buttonLink} onClick={this.sort('playerName')}>Player</button></th>
                            <th><button className={styles.buttonLink} onClick={this.sort('afl')}>AFL Club</button></th>
                            <th><button className={styles.buttonLink} onClick={this.sort('af', 'down')}>Avg F</button></th>
                            <th><button className={styles.buttonLink} onClick={this.sort('am', 'down')}>Avg M</button></th>
                            <th><button className={styles.buttonLink} onClick={this.sort('ar', 'down')}>Avg R</button></th>
                            <th><button className={styles.buttonLink} onClick={this.sort('at', 'down')}>Avg T</button></th>
                            <th><button className={styles.buttonLink} onClick={this.sort('games', 'down')}>Games</button></th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.stats.map(row)}
                    </tbody>
                </table>
            </div>
        );
    }
}